import { Component } from '@angular/core';

/**
 * "All plans include…" feature list shown on the Go Live page and the billing
 * tab. Mirrors the marketing pricing page (https://heyrosie.com/pricing).
 * Display-only copy — kept here as the single source of truth so the Go Live
 * page and billing tab can't drift apart.
 */
@Component({
  selector: 'rosie-all-plans-include',
  templateUrl: './all-plans-include.component.html',
  styleUrls: ['./all-plans-include.component.scss'],
  standalone: false,
})
export class AllPlansIncludeComponent {
  readonly features: string[] = [
    'Native iOS & Android apps',
    '24/7 availability – Rosie never sleeps, never takes breaks',
    'Handles multiple calls simultaneously – no busy signals, ever',
    'Trained on your business automatically – Rosie learns from your Google profile and website',
    'Custom FAQ & answers – teach Rosie how to answer common questions',
    '10+ agent voices to choose from',
    'Custom agent name & greeting',
    'English & Spanish on every call',
    'Pick your area code',
    'Call summaries, transcripts & recordings',
    'Email & text notifications for every call',
    'Zapier integration — connect to 1,000+ apps',
  ];
}
